import { api as reduxApi } from '@api/reduxApi';

type UseParticipantsCounts = {
  inviteableCount: number;
  netEligibleCount: number;
  netIneligibleCount: number;
  ineligibleCount: number;
  contactableCount: number;
  reinviteableCount: number;
  unsubscribedCount: number;
  isLoading: boolean;
};

interface Props {
  studyId: number;
  query?: ServerFilterQuery;
  ids?: number[];
}

export const useParticipantsAggregatedCounts = ({ studyId, query, ids }: Props): UseParticipantsCounts => {
  const { data, isLoading } = reduxApi.useGetParticipationStatusCountQuery({
    study_id: studyId,
    query: {
      filters: query?.filters || [],
      searchQuery: query?.q || undefined
    },
    ids
  });

  return {
    inviteableCount: data?.inviteable || 0,
    ineligibleCount: data?.ineligible || 0,
    contactableCount: data?.contactable || 0,
    reinviteableCount: data?.reinviteable || 0,
    unsubscribedCount: data?.unsubscribed || 0,
    netEligibleCount: data?.net_eligible || 0,
    netIneligibleCount: data?.net_ineligible || 0,
    isLoading
  };
};
